import React from 'react';

const Doorman = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <path
        d="M11.25 17.8125H6.5625"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 16.875V2.8125H22.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.1875 20.625V13.5938C27.1875 11.9776 26.5455 10.4276 25.4027 9.28482C24.2599 8.14202 22.7099 7.5 21.0938 7.5H8.90625C10.5224 7.5 12.0724 8.14202 13.2152 9.28482C14.358 10.4276 15 11.9776 15 13.5938V21.5625H26.25C26.4986 21.5625 26.7371 21.4637 26.9129 21.2879C27.0887 21.1121 27.1875 20.8736 27.1875 20.625Z"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 26.25V21.5625H3.75C3.50136 21.5625 3.2629 21.4637 3.08709 21.2879C2.91127 21.1121 2.8125 20.8736 2.8125 20.625V13.5938C2.8125 11.9776 3.45452 10.4276 4.59732 9.28482C5.74012 8.14202 7.29009 7.5 8.90625 7.5"
        stroke="#343330"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Doorman;
